module.exports = __webpack_public_path__ + "static/media/nav_trivia.f208fe0a.svg";